import { useState } from "react";
import { useRouter } from "Hooks/useRouter";
import { queryParamsToProps, goToReportPage } from "../services/queryParams";
import { useQuery } from "@apollo/client";
import queries from "Shared/queries";
import {
  PresettlementExclusionsQuery,
  PresettlementExclusionsQueryVariables,
} from "generated/graphql";

const ROWS_PER_REPORT_PAGE = 10;

export const usePresettlementExclusionsHook = () => {
  const { history, location } = useRouter();
  const queryParams = queryParamsToProps(location.search);
  const { page, payDate, searchTerm } = queryParams;
  const [defaultPayDate, setDefaultPayDate] = useState<string | undefined>(
    undefined
  );

  const onDefaultPayDateChange = (defaultPayDate: string) => {
    setDefaultPayDate(defaultPayDate);
  };

  const onChangePage = (
    evt: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => goToReportPage(history, { page: newPage, payDate, searchTerm });

  const onPayDateChange = (newPayDate?: string) =>
    goToReportPage(history, { page: 1, payDate: newPayDate, searchTerm });

  const onSearchTermChange = (newSearchTerm?: string) =>
    goToReportPage(history, { page: 1, payDate, searchTerm: newSearchTerm });

  const { data, loading, error } = useQuery<
    PresettlementExclusionsQuery,
    PresettlementExclusionsQueryVariables
  >(queries.GET_PRESETTLEMENT_EXCLUSIONS, {
    variables: {
      paymentExpectedOn: payDate || defaultPayDate,
      page,
      perPage: ROWS_PER_REPORT_PAGE,
      search: searchTerm,
    },
  });

  return {
    data: data?.presettlementExclusions,
    loading,
    error,
    onChangePage,
    onPayDateChange,
    onSearchTermChange,
    page,
    payDate,
    searchTerm,
    onDefaultPayDateChange,
  };
};
